module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/oee_3-1ebb0fcae5c6cfcb1a3a646ddadcb8df.png";